// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"a3751a41","453":"dad545f2","551":"021b4399"}[chunkId] + ".chunk.js";
};